import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { APP_STORAGE, AppStorage } from '~/app.storage';

export function authenticationInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (request.headers.has('Authorization')) {
    return next(request);
  }

  const storage = inject(APP_STORAGE);
  const router = inject(Router);

  const accessToken = storage.getItem(AppStorage.AccessToken);
  if (accessToken) {
    return next(authorize(request, accessToken)).pipe(
      catchError(error => {
        if (error.status === 401) {
          navigateToLogin(router);
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }

  return next(request).pipe(
    catchError(error => {
      if (error.status === 401) {
        navigateToLogin(router);
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
}

function authorize(request: HttpRequest<unknown>, bearerToken: string) {
  return request.clone({ setHeaders: { Authorization: `Bearer ${bearerToken}` } });
}

function navigateToLogin(router: Router) {
  void router.navigate(['auth', 'login'], { state: { origin: router.url } });
}
